<script>
import BaseView from '../base/base-view'
import getViewConfig from './guide-view-config'

export default {
    name: 'GuideView',
    // -------------------------------- Extends -------------------------------------
    extends: BaseView,

    // -------------------------------- Props ---------------------------------------
    props: {},
    // -------------------------------- Computed ------------------------------------
    computed:{
        guideViewConfig() {
            return getViewConfig(this.expandedLevels)
        }
    },

    methods:{
        beforeGoToView(){
            this.highlightGuideStep(-1)
        },
        highlightGuideStep(stepIndex){
            this.mapViewer.viewApi.set_selected_step(stepIndex)
        },
    },
    watch:{
        /* isActive:{
            handler: "highlightUnits",
            immediate: true,
        }*/
    },

    created(){
        //Each child view should call this method to include their view config prop name to inheritance collection
        this.addInheritedView('guideViewConfig')
    },
    beforeDestroy() {
        this.mapViewer.viewApi.restore_base_color()
    }
}
</script>
